<template>
  <div class="vocal-group" ref="vocalGroupRef">
    <div
      class="block"
      v-for="(item, index) in vocalGroup[type]"
      :key="index.toString()"
    >
      <div class="figure-box">
        <div class="figure">
          <el-progress
            :style="{ '--el-fill-color-light': 'transparent' }"
            stroke-linecap="square"
            type="circle"
            color="#fff"
            :width="createRenderType == 'pc' ? 164 : 122"
            :percentage="
              state.curPlayerData[item.link]?.isPlaying
                ? state.process * 100
                : 0
            "
            status="success"
          >
            <!--  -->
            <img class="avatar" :src="item.img" alt="" />
            <img
              v-if="!state.curPlayerData[item.link]?.isPlaying"
              @click="() => handlePlay(item.link, index)"
              :alt="item.link"
              class="play"
              src="@/assets/img/land/vocal/play.webp"
            />
            <img
              class="pause"
              v-if="state.curPlayerData[item.link]?.isPlaying"
              @click="() => handlePause(item.link)"
              src="@/assets/img/land/vocal/pause.webp"
            />
          </el-progress>
        </div>
      </div>
      <div class="caption">
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted, getCurrentInstance} from "vue";
import { isMobileDevice } from "@/utils/tools.js";
import { $$language, $$t } from "@/i18n/i18n.js";
import demo3 from "@/assets/img/credit/melody1.png";
import demo7 from "@/assets/img/credit/melody2.png";
import vocal1 from "@/assets/img/credit/vocal1.png";
import vocal2 from "@/assets/img/credit/vocal2.png";
import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();

const { createRenderType } = storeToRefs(createLayoutStore);

const appContext = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext;

const props = defineProps({
  type: {
    type: String,
    default: "reference",
  },
});

const state = reactive({
  isPlay: 0,
  curPlayerData: {},
  process: 0,
});

const left_icon_text1 = {
  reference: $$t("credit.reference"),
  voice: $$t("credit.vocal_audio"),
  melody: $$t("credit.melody_ideas"),
};

const left_icon_text2 = {
  reference: $$t("credit.generated"),
  voice: $$t("credit.generated"),
  melody: $$t("credit.generated"),
};

const vocalGroup = ref({
  reference: [
    {
      title: left_icon_text1[props.type],
      img: demo3,
      link: "/static/assets/music/mureka/04-demo.mp3",
    },
    {
      title: left_icon_text2[props.type],
      img: demo7,
      link: "/static/assets/music/mureka/05-demo.mp3",
    },
  ],
  voice: [
    {
      title: left_icon_text1[props.type],
      img: vocal1,
      link: "/static/assets/music/mureka/vocal1.mp3",
    },
    {
      title: left_icon_text2[props.type],
      img: vocal2,
      link: "/static/assets/music/mureka/vocal2.mp3",
    },
  ],
  melody: [
    {
      title: left_icon_text1[props.type],
      img: demo3,
      link: "/static/assets/music/mureka/04-demo.mp3",
    },
    {
      title: left_icon_text2[props.type],
      img: demo7,
      link: "/static/assets/music/mureka/05-demo.mp3",
    },
  ],
});

const handlePlay = (url, index) => {
  if (props.type != "voice") {
    firebaseUtils.logClickEvent("melodyideas_subcribepage", {
      exampletype: index == 0 ? "melodyideas" : "generated",
    });
  } else {
    firebaseUtils.logClickEvent("splashads_vocal_playdemo", {});
  }
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.seek(url, 0);
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.play(url);
  state.curPlayerData[url].isPlaying = true;
};

const handlePause = (url) => {
  state.curPlayerData[url].isPlaying = false;
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(url, true);
};

const register = (renderData) => {
  state.curPlayerData[renderData.url] = appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registerPlayUrl(
    renderData.url,
    {
      duration: renderData.duration_milliseconds ?? 0,
      personalizedConfig: {
        loop: false,
      },
      listeners: {
        onDurationChange({ duration }) {
          console.log("duration", duration);
        },
        onpause() {
          appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.seek(renderData.url, 0);
          state.curPlayerData[renderData.url].isPlaying = false;
          state.process = 0;
        },
        onPlayStateChange(isPlaying) {
          state.isPlay = isPlaying;
        },
        onLoadingStateChange() {},
        onPositionChange: (obj) => {
          // console.log("obj", obj.current, obj.end);
          state.process = obj.current / obj.end;
        },
      },
    }
  );
};

onMounted(() => {
  vocalGroup.value[props.type].forEach((item) => {
    register({ url: item.link });
  });
});

onUnmounted(() => {
  Object.values(state.curPlayerData).forEach((item) => {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releasePlayer(item);
  });
});
</script>

<style lang="scss" scoped>
.vocal-group {
  width: 100%;
  overflow: hidden;
  --el-fill-color-light: transparent;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  .block {
    display: inline-block;
    text-align: center;
    :deep(.el-progress__text) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .figure {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      // margin: 0 20px;
      // padding-top: 5px;
      box-sizing: border-box;
      height: 186px;
      width: 186px;
      border-radius: 200px;
      background: conic-gradient(
        from 180deg at 50% 50%,
        rgba(255, 255, 255, 0.34) -18deg,
        rgba(255, 255, 255, 0.14) 0deg,
        rgba(255, 255, 255, 0.09) 54deg,
        rgba(255, 255, 255, 0.3) 80deg,
        rgba(255, 255, 255, 0.02) 147deg,
        rgba(255, 255, 255, 0.28) 188deg,
        rgba(255, 255, 255, 0) 269deg,
        rgba(255, 255, 255, 0.34) 342deg,
        rgba(255, 255, 255, 0.14) 360deg
      );
      .play,
      .pause {
        z-index: 10;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 60px;
        height: 60px;
        opacity: 1;
        cursor: pointer;
        backdrop-filter: blur(2px); /* 毛玻璃模糊效果 */
        -webkit-backdrop-filter: blur(2px); /* Webkit 内核支持 */
        background-color: rgba(255, 255, 255, 0.2);
        // box-shadow: 0 4px 6px rgba(255, 255, 255, 0.2); /* 阴影效果 */
      }
      img {
        width: 158px;
        height: 158px;
        border-radius: 50%;
      }
      .pause {
        opacity: 1;
      }
      // &:hover {
      //   .play {
      //     opacity: 1;
      //   }
      // }
    }
    .caption {
      text-align: center;
      padding: 0px 24px;
      margin-top: 16px;
      font-size: 16px;
      font-weight: normal;
    }
  }
}
@media screen and (max-width: 768px) {
  .vocal-group {
    background: linear-gradient(122deg, #792a50 0%, #953e56 100%);
    box-shadow: inset 0px 0px 60px 0px rgba(0, 0, 0, 0.3);
    padding: 15px 0;
    .block {
      padding: 0;
      .figure {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0;
        width: 140px;
        height: 140px;
        border-radius: 200px;
        background: conic-gradient(
          from 180deg at 50% 50%,
          rgba(255, 255, 255, 0.34) -18deg,
          rgba(255, 255, 255, 0.14) 0deg,
          rgba(255, 255, 255, 0.09) 54deg,
          rgba(255, 255, 255, 0.3) 80deg,
          rgba(255, 255, 255, 0.02) 147deg,
          rgba(255, 255, 255, 0.28) 188deg,
          rgba(255, 255, 255, 0) 269deg,
          rgba(255, 255, 255, 0.34) 342deg,
          rgba(255, 255, 255, 0.14) 360deg
        );
        .play,
        .pause {
          width: 40px;
          height: 40px;
          backdrop-filter: blur(10px); /* 毛玻璃模糊效果 */
          -webkit-backdrop-filter: blur(10px); /* Webkit 内核支持 */
          // box-shadow: 0 4px 6px rgba(255, 255, 255, 0.2); /* 阴影效果 */
          background-color: rgba(255, 255, 255, 0.2);
        }
        img {
          width: 115px;
          height: 115px;
        }
      }
      .caption {
        width: 100%;
        padding: 2px;
        text-align: center;
        margin-top: 12px;
        font-size: 14px;
      }
    }
  }
}
</style>
